module.exports = __webpack_public_path__ + "static/SpaceMono-Regular-a77149c6f33e4063f2b928b31304ee07.woff2";